import { isNumberLike } from "@/utils";
import { multiply, fmoney } from "@/utils/count";
import { dateFormat } from "@/utils/date";
export default {
  filters: {
    // 千分位金额
    thousands(val) {
      if (isNumberLike(val)) {
        const amount = fmoney(val, 2);
        return amount;
      } else {
        return "";
      }
    },
    // 将小数转成百分比
    percentage(val) {
      if (isNumberLike(val)) {
        const newVal = multiply(val, 100);
        return `${Number(newVal)}%`;
      } else {
        return "";
      }
    },
    // 时间戳(秒)转日期格式: yyyy-MM-dd hh:mm:ss
    parseTimeSecond(second) {
      if (second) {
        return dateFormat(new Date(second * 1000));
      }
      return "";
    },
  },
};
